import { memo } from 'react';
import { Select } from 'antd';
import { useFilterOption } from '../../hooks/shared/useFilterOption';
import { Props } from './types';
import styles from './style.module.css';

const UISelect = memo(
  ({ titleSelect, option, selected, onSelectedChange, showTags }: Props) => {
    const filterOption = useFilterOption();

    return (
      <Select
        allowClear
        mode="multiple"
        className={styles.select}
        placeholder={titleSelect}
        defaultValue={[]}
        filterOption={filterOption}
        value={selected}
        onChange={(value) => onSelectedChange(value)}
        tagRender={showTags ? undefined : () => <></>}
        maxTagCount="responsive"
        maxTagTextLength={24}
        removeIcon={null}
      >
        {option !== undefined
          ? option.map((topic, index) => (
              <Select.Option key={index} value={topic.id}>
                {topic.name}
              </Select.Option>
            ))
          : null}
      </Select>
    );
  },
);

UISelect.displayName = 'UISelect';
export default UISelect;
